
// Do not type this object, we'll loose auto-complete of all the properties.
export const SPELL_ID = {

    DK: {
        BLOOD: {},
        FROST: {},
        UNHOLY: {},
    },

    DH: {
        VENG: {},
        HAVOC: {
            DARK: "2268f148-7a76-4187-a362-57f11941ee75",
        },
    },

    DRUID: {
        RESTO: {
            TRANQ: "5dbe0161-0e1c-45b1-b055-dc8c6ae0b68e",
            TREE: "96876d51-260a-4375-ae51-3876ed29e143",
        },
        GUARD: {
            STAMP_ROAR: "b528aecc-a61f-4fba-982a-d8b589c73346",
        },
        FERAL: {
            STAMP_ROAR: "eeca1fac-c243-43fa-adfe-1cceafadf3fe",
        }
    },

    HUNTER: {
        BM: {},
        MM: {},
        SV: {},
    },

    MAGE: {
        FROST: {},
        FIRE: {},
        ARCANE: {},
    },

    MONK: {
        BRM: {},
        MW: {
            REVIVAL: "b95ae4a5-7baf-4f17-af19-1ed99748cc41",
            CHI_JI: "4f6f9ae9-128d-4479-908e-6c670507040f",
        },
        WW: {},
    },

    PALADIN: {
        PROT: {},
        RET: {},
        HOLY: {
            AM: "687c6b0e-fb39-463c-bbbf-ec91840e0edf",
            WINGS: "418adfbc-cdad-4753-bbeb-fefa483e8fc3",
        },
    },

    PRIEST: {
        HOLY: {
            DIVINE_HYMN: "914b0d22-87d2-466f-aa49-0ff4c2e79470",
            SALVATION: "1519125e-734a-455b-8511-39ad3ed93783",
        },
        DISC: {
            RAPTURE: "fc403a45-3904-40a4-8c5c-9eecfbdbbfc8",
            EVANGELISM: "53815017-c9dd-40ae-8590-6200fbb2a322",
            BARRIER: "c7542e07-a661-4f85-a537-67f0dc1185da",
            SHADOWFIEND: "d57d8dda-3171-4adb-a518-b99c88983f41",
            MINDBENDER: "887367f0-ad87-410f-9b18-56ec26791758",
        },
        SHADOW: {
            VAMPIRIC_EMBRACE: "db0b42ae-5456-4436-98fd-cc9d3fe761f1",
        },
    },

    ROGUE: {
        OUT: {},
        SIN: {},
        SUB: {},
    },

    SHAMAN: {
        RESTO: {
            HTT: "3f9d8a36-d1c0-4038-8046-5afdc3cd3daa",
            SLT: "6131f05e-0d31-4bad-a596-32e7c6c5ad6a",
            APT: "d9209eb3-6335-4189-860f-3ec80ae5217d",
            WRT: "c4ef4a58-f9d4-4c22-8c64-c8cf7d020c2e",
        },
        ELE: {},
        ENH: {},
    },

    WARLOCK: {
        DEST: {},
        AFFLI: {},
        DEMO: {},
    },

    WARRIOR: {
        PROT: {
            RC: "10cce97d-9611-4e82-94a6-837bd658c8d0",
        },
        ARMS: {},
        FURY: {},
    },

}
